import React from "react";
import {
  Collapse,
  IconButton,
  List,
  MenuItem,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import { MenuItemType } from "../../../../../types/menu.type";
import { isArray } from "lodash";
import SidebarItem from "./SidebarItem";
import { Link, useLocation } from "react-router-dom";
import { LuChevronDown, LuChevronRight } from "react-icons/lu";

interface ISidebarList {
  sx?: SxProps;
  path?: string;
  subheaderText?: string;
  items?: MenuItemType[];
  expand: boolean;
  onSubHeaderClick: () => void;
}

function SidebarList({
  subheaderText,
  sx,
  path,
  items,
  expand,
  onSubHeaderClick,
  ...props
}: ISidebarList) {
  const location = useLocation();
  const hasSub = isArray(items) && items?.length > 0;

  return (
    <List
      component="nav"
      subheader={
        subheaderText ? (
          <Stack
            component={MenuItem}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ py: 1 }}
            onClick={onSubHeaderClick}
          >
            {hasSub ? (
              <Typography sx={{ color: "text.secondary", fontWeight: 600 }}>
                {subheaderText}
              </Typography>
            ) : (
              <Link
                to={path as string}
                style={{ display: "block", width: "100%", height: "100%" }}
              >
                <Typography
                  sx={{
                    color:
                      path === location.pathname
                        ? "primary.main"
                        : "text.secondary",
                    fontWeight: 600,
                  }}
                >
                  {subheaderText}
                </Typography>
              </Link>
            )}

            {hasSub && (
              <IconButton>
                {expand ? (
                  <LuChevronDown size={16} />
                ) : (
                  <LuChevronRight size={16} />
                )}
              </IconButton>
            )}
          </Stack>
        ) : null
      }
      sx={{ px: 2, ...sx }}
      {...props}
    >
      {hasSub && (
        <Collapse in={expand}>
          {items.map((item, index) => {
            let active = item.path === "/" && location.pathname === "/";
            if (item.path && item.path !== "/") {
              active = location.pathname.includes(item.path);
            }
            return (
              <SidebarItem
                key={index}
                text={item.text}
                Icon={item.Icon}
                href={item.path}
                active={active}
              />
            );
          })}
        </Collapse>
      )}
    </List>
  );
}

export default SidebarList;
